(function () {
  const form = document.getElementById('wb-request-form');
  if (!form) return;

  const status = form.querySelector('.wb-request__status');
  const submit = form.querySelector('.wb-request__submit');

  function setStatus(msg, kind) {
    status.textContent = msg || '';
    status.dataset.kind = kind || '';
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    setStatus('', '');

    const data = {
      title: form.title.value.trim(),
      volume: form.volume.value.trim(),
      edition: form.edition.value,
      type: form.type ? form.type.value : 'either',
      condition: form.condition.value,
      notes: form.notes.value.trim(),
      email: (form.email && form.email.value || '').trim(),
    };

    if (!data.title) {
      setStatus('Please enter a title.', 'error');
      return;
    }
    if (!data.volume) {
      setStatus('Please enter a volume number (use "any" if it doesn\'t matter).', 'error');
      return;
    }
    if (!form.querySelector('input[type="hidden"][name="email"]') && !data.email) {
      setStatus('Please enter your email.', 'error');
      return;
    }

    submit.disabled = true;
    submit.textContent = 'Sending...';

    try {
      const res = await fetch('/apps/wb/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const json = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(json.error || `Server returned ${res.status}`);
      }

      form.reset();
      setStatus('Added to your wishlist — we\'ll let you know if we find it.', 'success');
      document.dispatchEvent(new CustomEvent('wb:request-submitted'));
    } catch (err) {
      setStatus(err.message || 'Something went wrong. Please try again.', 'error');
    } finally {
      submit.disabled = false;
      submit.textContent = 'Request a Manga';
    }
  });
})();
